import { Controller } from 'stimulus';
import '@/js/modules/jquery_modal_defaults';

export default class extends Controller {
  static values = {
    targetModal: String,
  };

  connect() {
    this.onClose = () => this.dispatch('close');
    $(this.element).on($.modal.CLOSE, this.onClose);
  }

  disconnect() {
    $(this.element).off($.modal.CLOSE, this.onClose);
  }

  close() {
    $.modal.close();
  }

  closeAndOpen() {
    $.modal.close();

    // Timeout to open modal after close complete
    setTimeout(() => {
      $(this.targetModalValue).modal();
    }, 0);
  }
}
